import React from "react";
import ReactDOM from "react-dom/client";
import font400Url from "@fontsource/noto-sans-sc/files/noto-sans-sc-chinese-simplified-400-normal.woff?url";
import font500Url from "@fontsource/noto-sans-sc/files/noto-sans-sc-chinese-simplified-500-normal.woff?url";
import font600Url from "@fontsource/noto-sans-sc/files/noto-sans-sc-chinese-simplified-600-normal.woff?url";
import "./styles.css";
import { App } from "./App";

const fontStyles = document.createElement("style");
fontStyles.textContent = `
  @font-face { font-family: "Noto Sans SC"; font-style: normal; font-display: swap; font-weight: 400; src: url("${font400Url}") format("woff"); }
  @font-face { font-family: "Noto Sans SC"; font-style: normal; font-display: swap; font-weight: 500; src: url("${font500Url}") format("woff"); }
  @font-face { font-family: "Noto Sans SC"; font-style: normal; font-display: swap; font-weight: 600; src: url("${font600Url}") format("woff"); }
`;
document.head.append(fontStyles);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
